// deprecated - old event that may still be used in some spreadsheets
import { pushDataObject } from '../../tracker/data-layer';

import { type PushCalculoFretePdpProps } from './types';
import { getDeadlineMessage } from './utils';

export const pushCalculoFretePdp = (props: PushCalculoFretePdpProps) => {
  const { cheapestModality, region, shopName, zipCode } = props;

  const regionLabel =
    region.city && region.stateCode
      ? `${region.city} - ${region.stateCode}`
      : undefined;

  pushDataObject({
    _clear: true,
    event: 'calculo-frete-pdp',
    CidadeEstado: regionLabel,
    CEP: zipCode,
    Seller: shopName,
    'prazo-frete': getDeadlineMessage(cheapestModality),
    value: cheapestModality?.cost ?? 0,
  });
};
